/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

const useUserAccess = () => {
  const session = useSelector((state: ApplicationState) => state.session.data);
  const permission = (session && session.permission) || {};
  return permission;
};
export default useUserAccess;
